import React, { useContext, useEffect, useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
  IconButton,
  useMediaQuery,
  Collapse,
  AppBar,
  Toolbar,
  Grid,
  Tooltip,
  Button,
  MenuItem,
  Menu,
  Divider,
} from "@mui/material";
import {
  customer_nav,
  Admin_nav,
  developers_nav,
  merchants_nav,
  backend_nav,
  trainee_nav,
  accounts_nav,
  Asm_nav,
} from "../_nav"; // Assuming both are imported from the same source
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import AuthContext from "../store/AuthContext";
import { Avatar } from "@mui/material";
import { femaleAvatar, maleAvatar } from "../iconsImports";
import LogOutModal from "./Biggbarains/LogOutModal";
import { setTitleFunc } from "../utils/HeaderTitleUtil";
import ViewModal from "../modals/ViewModal";
import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";

const drawerWidth = 260;
const SidenavBar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState({});
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation(); // Get current route
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const user = authCtx.user; // 'customer' or 'admin'
  const [openDialog, setOpenDialog] = useState(false);
  const [punchOut, setPunchOut] = useState(false);
  const title = setTitleFunc(location.pathname, location.state);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handleOpenDialog = () => {
    setOpenDialog(true);
    handleMenuClose();
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handlePuchOut = () => {
    setPunchOut(true);
  };
  const handleLogout = () => {
    authCtx.logout();
    setAnchorEl(null);
    navigate("/");
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleSubMenuToggle = (index) => {
    setOpenSubMenu((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  const navItems =
    user.role === "Admin"
      ? Admin_nav
      : user.role === "Developer"
      ? developers_nav
      : user.role === "Backend"
      ? backend_nav
      : user.role === "Trainee"
      ? trainee_nav
      : user.role === "Accounts"
      ? accounts_nav
      : user.role === "ASM"
      ? Asm_nav
      : merchants_nav;

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
      <AppBar
        position="fixed"
        sx={{
          width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backgroundColor: isScrolled ? "white" : "transparent",
          boxShadow: isScrolled ? 3 : "none",
          transition: "all 0.3s ease",
          borderRadius: { xs: 0, sm: "0 0 0 20px" },
        }}
      >
        <Toolbar>
          <Typography
            sx={{
              fontWeight: "bold",
              color: "black",
              fontSize: "1.6rem",
              m: 3,
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            {title}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />

          <Button
            onClick={handleMenuOpen}
            sx={{
              borderRadius: "0px",
              p: 0,
              textAlign: "right",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
            color="inherit"
          >
            <Tooltip title="MY Profile" placement="bottom">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    color: "#000",
                    fontWeight: 600,
                  }}
                >
                  {user?.name}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ color: " #808080", fontWeight: 600 }}
                >
                  {user?.role} PROFILE
                </Typography>
              </Box>
            </Tooltip>

            {!Boolean(anchorEl) && (
              <ViewModal
                row={user}
                title="View Profile Image"
                fileKey="profile_image"
                view="profileImage"
                sx={{ width: 45, height: 45 }}
              />

              // <Avatar
              //   alt={user?.name}
              //   src={user?.gender === "Female" ? femaleAvatar : maleAvatar}
              //   sx={{ width: 40, height: 40 }}
              // />
            )}
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            disablePortal
            sx={{
              "& .MuiPaper-root": {
                minWidth: 250,
                borderRadius: 2,
                boxShadow: 3,
                marginTop: "0.3rem",
                m: "0.5",
                zIndex: 1300,
              },
            }}
          >
            <Box
              sx={{
                padding: "12px 18px",
                display: "flex",
                alignItems: "center",

                gap: 2,
                backgroundColor: "#fff",
                borderRadius: "14px",
                m: 0.2,

                transition: "0.3s",
                "&:hover": { boxShadow: "0 6px 16px rgba(0,0,0,0.15)" },
              }}
            >
              <ViewModal
                row={user}
                title="View Profile Image"
                fileKey="profile_image"
                view="profileImage"
                sx={{ width: 55, height: 55 }}
              />

              {/* <Avatar
                alt={user?.name}
                src={user?.gender === "Female" ? femaleAvatar : maleAvatar}
                sx={{
                  width: 46,
                  height: 46,
                  border: "2px solid #1976d2",
                  p: 0.2,
                }}
              /> */}
              <Box>
                <Typography
                  sx={{ fontWeight: 700, fontSize: "18px", color: "#222" }}
                >
                  {user?.name}
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#666" }}>
                  {user?.email}
                </Typography>
              </Box>
            </Box>

            <Divider sx={{ my: 1, backgroundColor: "#ccc" }} />

            <MenuItem
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#1976d2",
                transition: "0.3s",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span
                onClick={() => {
                  if (user && user.role === "Admin") {
                    navigate("/admin/my_profile");
                  } else if (user && user.role === "Developer") {
                    navigate("/developer/my_profile");
                  } else if (user && user.role === "Merchant") {
                    navigate("/merchant/my_profile");
                  } else if (user && user.role === "Trainee") {
                    navigate("/trainee/my_profile");
                  } else if (user && user.role === "Backend") {
                    navigate("/backend/my_profile");
                  } else if (user && user.role === "Accounts") {
                    navigate("/accounts/my_profile");
                  } else {
                    navigate("/other/my-profile");
                  }
                  handleMenuClose();
                }}
                style={{
                  borderRadius: "10px",
                  padding: "0.4rem 1.3rem",
                  fontSize: "1rem",
                  fontWeight: "600",
                  backgroundColor: "rgb(53, 65, 92)",
                  color: "#fff",
                  cursor: "pointer",

                  display: "inline-block",

                  textAlign: "left",
                }}
              >
                Manage your Profile
              </span>
            </MenuItem>
            <Divider sx={{ my: 1, backgroundColor: "#ccc" }} />
            <MenuItem
              onClick={handleLogout}
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                color: "#fff",
                backgroundColor: "#d32f2f",
                padding: "0.5rem 1.4rem",
                borderRadius: "10px",
                display: "inline-block",
                m: 1.3,

                gap: 1.2,
                "&:hover": {
                  backgroundColor: "#b71c1c",
                },
              }}
            >
              <LogoutIcon sx={{ color: "#fff" }} /> Sign Out
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {isSmallScreen && (
        <IconButton
          onClick={handleDrawerToggle}
          sx={{
            position: "absolute",
            top: 10,
            left: 10,
            zIndex: 1201,
            color: "blue",
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      {/* Sidebar Drawer */}
      <Drawer
        variant={isSmallScreen ? "temporary" : "permanent"}
        open={isSmallScreen ? mobileOpen : true}
        onClose={handleDrawerToggle}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#2f3b57",
            color: "#fff",
            borderRadius: { xs: 0, sm: 2 },
            m: { xs: 0, sm: 2 },
            mt: { xs: 0, sm: 3 },
            height: { xs: "100vh", sm: "calc(100vh - 24px)" },
            borderRight: {
              xs: "none",
              sm: "1px solid rgba(255, 255, 255, 0.12)",
            },
            overflowY: "auto",
            scrollbarWidth: "thin",
            scrollbarColor: "#4FC3F7 transparent",
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#4FC3F7",
              borderRadius: "3px",
            },
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          {/* Header section */}
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              backgroundColor: "#2f3b57",
              pt: 1,
              pb: 1,
            }}
          >
            {isSmallScreen && (
              <IconButton
                onClick={handleDrawerToggle}
                sx={{
                  color: "#fff",
                  position: "absolute",
                  right: 8,
                  top: 8,
                }}
              >
                <CloseIcon />
              </IconButton>
            )}

            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              px={2}
              py={1}
            >
              <ViewModal
                row={user}
                title="View Profile Image"
                fileKey="profile_image"
                view="profileImage"
                width
                height
                fontSize
                sx={{
                  border: "4px solid white",
                  boxShadow: "0 0 12px rgba(255,255,255,0.4)",
                  minWidth: "60px",
                  minHeight: "60px",
                }}
              />

              <Typography
                sx={{
                  color: "#fff",
                  ml: 2,
                  flexGrow: 1,
                  textAlign: "left",
                  textTransform: "uppercase",
                  wordBreak: "break-word",
                  pr: isSmallScreen ? 4 : 0,
                }}
              >
                <span
                  style={{
                    fontSize: { xs: "16px", sm: "20px" },
                    fontWeight: "bold",
                    letterSpacing: "1px",
                    display: "inline-block",
                    maxWidth: "180px",
                  }}
                >
                  {user?.name}
                </span>
              </Typography>
            </Box>
          </Box>

          {/* Scrollable content */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              px: 1,
            }}
          >
            <List>
              {navItems.map((item, index) => {
                const isActive = location.pathname === item.to;

                return (
                  <div key={index}>
                    {/* Main menu item */}
                    <ListItem
                      button
                      onClick={() => {
                        if (item.subMenu) {
                          handleSubMenuToggle(index);
                        } else {
                          navigate(item.to);
                        }
                      }}
                      sx={{
                        backgroundColor: isActive ? "#1e293b" : "transparent",
                        color: isActive ? "#4FC3F7" : "#fff",
                        borderRadius: 2,
                        mb: 1,
                        "&:hover": {
                          backgroundColor: "#1e293b",
                        },
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: "36px" }}>
                        {typeof item.icon === "string" ? (
                          <img
                            src={item.icon}
                            alt={item.title}
                            style={{ width: 24, height: 24 }}
                          />
                        ) : (
                          React.cloneElement(item.icon, {
                            sx: { color: isActive ? "#4FC3F7" : "#fff" },
                          })
                        )}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.title}
                        primaryTypographyProps={{
                          sx: {
                            fontSize: { xs: "0.875rem", sm: "1rem" },
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          },
                        }}
                      />
                      {item.subMenu && (
                        <ArrowDropDownOutlinedIcon
                          sx={{
                            color: "#fff",
                            transform: openSubMenu[index]
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      )}
                    </ListItem>

                    {/* Submenu items */}
                    {item.subMenu && (
                      <Collapse
                        in={openSubMenu[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List component="div" disablePadding>
                          {item.subMenu.map((subItem, subIndex) => {
                            const isSubActive =
                              location.pathname === subItem.to;

                            return (
                              <ListItem
                                key={subIndex}
                                button
                                onClick={() => navigate(subItem.to)}
                                sx={{
                                  pl: 4,
                                  backgroundColor: isSubActive
                                    ? "#1e293b"
                                    : "transparent",
                                  color: isSubActive ? "#4FC3F7" : "#fff",
                                  borderRadius: 2,
                                  mb: 0.5,
                                  "&:hover": {
                                    backgroundColor: "#1e293b",
                                    color: "#fff",
                                  },
                                }}
                              >
                                <ListItemIcon sx={{ minWidth: "36px" }}>
                                  {typeof subItem.icon === "string" ? (
                                    <img
                                      src={subItem.icon}
                                      alt={subItem.title}
                                      style={{ width: 20, height: 20 }}
                                    />
                                  ) : (
                                    React.cloneElement(subItem.icon, {
                                      sx: {
                                        color: isSubActive ? "#4FC3F7" : "#fff",
                                      },
                                    })
                                  )}
                                </ListItemIcon>
                                <ListItemText
                                  primary={subItem.title}
                                  primaryTypographyProps={{
                                    sx: {
                                      fontSize: {
                                        xs: "0.8125rem",
                                        sm: "0.875rem",
                                      },
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    },
                                  }}
                                />
                              </ListItem>
                            );
                          })}
                        </List>
                      </Collapse>
                    )}
                  </div>
                );
              })}
            </List>
            <Box
              sx={{
                position: "sticky",
                bottom: 0,
                backgroundColor: "#2f3b57",
                pt: 1,
                pb: 1,
                mt: 10,
              }}
            >
              <List>
                <ListItem
                  button
                  onClick={handleLogout}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#1e293b",
                    },
                  }}
                >
                  <ListItemIcon>
                    <LogoutIcon sx={{ color: "#fff" }} />
                  </ListItemIcon>
                  <ListItemText primary="Logout" />
                </ListItem>
              </List>
            </Box>
          </Box>
        </Box>
      </Drawer>

      <Box
        component="main"
        sx={{ flexGrow: 1, p: 2, ml: 2, mt: 5, overflowX: "scroll" }}
      >
        <Outlet />
        <Grid md={12} sx={{ textAlign: "center", px: 4, mt: 1 }}>
          <Typography sx={{ color: "#777", fontSize: "14px", mt: 1 }}>
            <span className="mx-1">© Copyright 2025</span>
            {process.env.REACT_APP_TITLE === "tms.biggbrains"
              ? "BIGGBRAINS SOLUTIONS PRIVATE LIMITED"
              : process.env.REACT_APP_TITLE || ""}
            <span className="mx-1">
              Solutions Pvt Ltd. All Rights Reserved.
            </span>
          </Typography>
          <Typography sx={{ color: "#888", fontSize: "14px", mt: 0.5 }}>
            Disclaimer: Any dispute arising under these terms and conditions
            shall be subject to the jurisdiction of the courts of Delhi.
          </Typography>
        </Grid>
      </Box>
    </Box>
  );
};

export default SidenavBar;
